import { InternalPayItemConnectionClassTypeItem } from './InternalPayItemConnectionClassTypeItem'
import { CIMSModule } from '../../CIMSModule'

export const CAS = new InternalPayItemConnectionClassTypeItem({
  id: '3A42D318-B926-4140-94DA-BE3A662C8A49',
  module: CIMSModule.CAS,
  classType: 'ConstructionAdminSubmittal',
})
export const FDC = new InternalPayItemConnectionClassTypeItem({
  id: '0DEF659B-68FE-4367-980D-A386DA14CCB7',
  module: CIMSModule.FDC,
  classType: 'FieldDesignChange',
})
export const CTS = new InternalPayItemConnectionClassTypeItem({
  id: 'C32CA42D-E82D-4CCA-94F3-CFD1FCFACB37',
  module: CIMSModule.Concrete,
  classType: 'ConcreteTestSet',
})
export const DS = new InternalPayItemConnectionClassTypeItem({
  id: '8D1FAC90-DD33-4491-BC21-E4E38498C3B7',
  module: CIMSModule.DS,
  classType: 'DesignSubmittal',
})
export const Issue = new InternalPayItemConnectionClassTypeItem({
  id: 'D4E5795F-A5FF-49FC-875F-AD3063BF457F',
  module: CIMSModule.Issues,
  classType: 'Issue',
})
export const EJ = new InternalPayItemConnectionClassTypeItem({
  id: '0AA7A7C7-0824-473F-9540-0B46C9F6A63E',
  module: CIMSModule.EJ,
  classType: 'EngineeringJudgement',
})
